import { createVPhoneInput, VPhoneCountryFlagSvg } from 'v-phone-input';
import { VSelect } from 'vuetify/components';

import 'flag-icons/css/flag-icons.min.css';
import 'v-phone-input/styles';

/**
 * Champ téléphone officiel.
 *
 * `v-phone-input` est le composant retenu partout ailleurs — la borne Koesio,
 * le back-office Wheelskeep — et il n'y a aucune raison d'en écrire un autre :
 * il connaît les deux cents plans de numérotation, sait reconnaître un numéro
 * collé sous n'importe quelle forme, et devine le pays à la frappe. Un
 * sélecteur maison ne rattraperait jamais ce travail.
 *
 * La configuration est ici et pas dans chaque application : le front public, la
 * borne et le back-office doivent présenter le même champ, sans quoi un numéro
 * saisi d'un côté ne se relit pas de l'autre.
 */
export default createVPhoneInput({
	countryInputComponent: VSelect,
	countryDisplayComponent: VPhoneCountryFlagSvg,
	// Le sélecteur d'indicatif ne s'efface pas : un numéro sans pays n'a pas de
	// sens, et la croix ne ferait qu'ouvrir un état impossible à corriger.
	countryProps: { clearable: false },
});
